import { EnduserFormWizardBody } from "./EnduserFormWizardBody";
import { useFormResponseDialogShallowStore } from "../store";
import type { SurfaceWizardProps } from "./types";

/** The wizard as rendered by the portal's form-response dialog, bound to that surface's store. */
export const FormResponseDialogWizard = (props: SurfaceWizardProps) => (
  <EnduserFormWizardBody {...props} useFormShallowStore={useFormResponseDialogShallowStore} />
);
